import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import SuperAdmin from "./pages/SuperAdmin";
import CafePublic from "./pages/CafePublic";
import Discover from "./pages/Discover";
import VerifyEmail from "./pages/VerifyEmail";
import { PasswordResetRequest, PasswordResetConfirm } from "./pages/PasswordReset";
import MapPage from "./pages/MapPage";
import Legal from "./pages/Legal";
import FAQ from "./pages/FAQ";
import WhyCafeSpot from "./pages/WhyCafeSpot";
import BillingComplete from "./pages/BillingComplete";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/discover" element={<Discover />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/cafe/:slug" element={<CafePublic />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<PasswordResetRequest />} />
            <Route path="/reset-password/:token" element={<PasswordResetConfirm />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal/:page" element={<Legal />} />
            <Route path="/faq" element={<FAQ />}/>
            <Route path="/why" element={<WhyCafeSpot />} />
            <Route path="/pourquoi" element={<WhyCafeSpot />} />
            <Route path="/billing/complete" element={<BillingComplete />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/super-admin/*" element={<SuperAdmin />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
